<template>
  <component
    :is="is"
    :class="rootClassName"
    v-bind="$attrs"
    v-on="$listeners"
  > 
    <slot />
  </component>
</template>

<script>

const variantComponents = {
  headingOne: 'h1',
  headingTwo: 'h2',
  headingThree: 'h3',
  headingFour: 'h4',
  headingFive: 'h5',
  headingSix: 'h6',
	label: 'label',
	paragraph: 'p',
  link: 'a',
  caption: 'span'
}

export default {

  name: 'Typography',

  props: {
		
    component: {
      type: [ String, Object ]
    },

    fontColor: {
      type: String,
      default: 'secondary-dark'
    },

    variant: {
			type: String,
			default: 'paragraph'
    },

    fontWeight: {
      type: String
    },

    fontSize: {
      type: String
    }
  },

  computed: {
    is () {
      if (this.component) return this.component
      const component = variantComponents[this.variant]
      if (component) return component
      return 'p'
    },

    rootClassName () {
      return [
        'm-0',
        this.$style.root,
        this.$style[this.variant],
        {
          [ `text-${this.fontColor}` ]: this.fontColor,
          [ `text-${this.fontSize}` ]: this.fontSize,
          [ `font-${this.fontWeight}` ]: this.fontWeight 
        }
      ]
    }
  }
}

</script>

<style module>

.root {
	@apply
		text-base
		font-medium;
}

.headingOne {
	@apply
    text-3xl;
}

.headingTwo {
	@apply
    text-2xl;
}

.headingThree {
	@apply
    text-xl;
}

.headingFour {
	@apply
    text-lg;
}

.headingFive {
	@apply
    text-base;
}

.headingSix {
	@apply
    text-sm;
}

.label {
	@apply
		text-secondary-dark
    text-sm;
}

.link {
	@apply
		text-primary
		text-base
}

.paragraph {
	@apply
		text-dull-dark
		text-base
}

.caption {
	@apply 
		text-dull-dark
		text-xs
}

</style>
